export const DASHBOARD_ANALYSIS_SUSTAINABILITY =
  '/dashboard/analysis/sustainability'
